/**
 * Service for fetching and handling the sample resume
 */

/**
 * Fetch the sample resume from the server and convert it to a File object
 * @returns A File object containing the sample resume PDF
 */
export async function fetchSampleResume(): Promise<File> {
  const apiBaseUrl = import.meta.env.VITE_API_URL || 'http://localhost:4000'
  const url = `${apiBaseUrl}/sample-resume`

  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
  })

  if (!response.ok) {
    throw new Error(
      `Failed to fetch sample resume: ${response.status} ${response.statusText}`
    )
  }

  const blob = await response.blob()

  // Convert blob to File object with a meaningful name
  const file = new File([blob], 'sample-resume.pdf', {
    type: 'application/pdf',
    lastModified: Date.now(),
  })

  return file
}

export const SampleResumeService = {
  fetchSampleResume,
}
